export class ResetPasswordModel {
    password_reset_token!: string;
    password!: string;
    confirm_password!: string;
    client_id!: any;
}
